// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wellbeing-container{height:100vh;width:100%;background-color:#f2f2f2}.input-wrapper{height:3em}.email-input{-webkit-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto;height:100%}.email-input input{padding-left:15px}.registration-message{width:35em;text-align:center}", ""]);
// Exports
module.exports = exports;
